import { makeStyles } from "@material-ui/core/styles";

const myTeamsPageStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    backgroundColor: theme.palette.primary.main,
  },
  topBarIcon: {
    color: theme.palette.text.primary,
  },
  tableHeaderCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    backgroundColor: "transparent !important",
    color: `${theme.palette.text.tertiary} !important`,
    width: "25%",
    fontFamily: "Poppins !important",
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    color: "#fff !important",
    width: "25%",
    fontFamily: "Poppins !important",
  },
  contentContainer: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginTop: "16px",
    // marginBottom: "16px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
  },
  inviteButton: {
    backgroundColor: `${theme.palette.secondary.main}`,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  backButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  iconButton: {
    borderRadius: "10px !important",
    border: `2px solid ${theme.palette.secondary.main} !important`,
  },
  tabs: {
    textTransform: "none !important",
  },
  tableHeaderCell: {
    borderBottom: `1px solid ${theme.palette.secondary.main} !important`,
    backgroundColor: "transparent !important",
    color: `${theme.palette.text.tertiary} !important`,
    width: "25%",
    fontFamily: "Poppins !important",
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.secondary.light} !important`,
    color: "#fff !important",
    width: "25%",
  },
  menuItem: {
    color: "#fff",
    borderRadius: "8px",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "&:hover": {
      backgroundColor: "#3E4759",
    },
  },
  listIcon: {
    minWidth: "max-content !important",
    color: "#fff",
  },
  listText: {
    fontSize: "14px",
    color: "#fff",
  },
  button: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    width: "200px",
    color: "#fff",
    borderRadius: "10px !important",
    padding: "12px 16px",
    fontSize: "14px",
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  // invite to project modal styles
  inviteToProjectModalRoot: {
    width: "40%",
    // height: "87%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0px 19px 45px 0px #0000001F",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },
  cardContentInput2: {
    padding: "4px 6px",

    "& .MuiInputBase-input": {
      padding: "10px 16px",
      backgroundColor: "#252A38",
      opacity: 1,
      fontSize: "16px",
      color: "white",
      fontFamily: "poppins",
      borderRadius: "10px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
    },
    "&.Mui-disabled .MuiInputBase-input": {
      color: "gray",
    },
  },

  // my team details page design

  dropdownStyle: {
    width: "100%",
    height: "40px",
    backgroundColor: "#252A38",
    color: "#fff",
    borderRadius: "10px",
    border: "none",
    padding: "10px 8px !important",

    "& .MuiSelect-select": {
      color: "#fff",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
    "& .MuiSelect-iconOpen": {
      color: "#fff",
    },

    // 🔥 added focus border color
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "gray !important",
    },
    // ensure default outline stays off on blur
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
  },

  singleMenuItem: {
    color: "#fff !important",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontFamily: "Poppins, sans-serif !important",
  },
  teamDetailsSidebar: {
    backgroundColor: "#252A38",
    height: `calc(100vh - 200px)`,
    padding: "10px",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "4px",
  },
  sidebarSingleItem: {
    padding: "8px 12px",
    borderRadius: "6px",
    display: "flex",
    gap: "8px",
    alignItems: "center",
    color: "#F9F9F9",
  },
  dangerButton: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    color: "#FF4141",
    justifyContent: "flex-start",
    "&:hover": {
      backgroundColor: "#D61F1F29",
      color: "#FF4141",
    },
  },
  teamDetailsRightSideTop: {
    height: "100%",
    borderRadius: "10px",
    display: "flex",
    gap: "16px",
    marginBottom: "10px",
  },
  teamDetailsRightSideTopSingleItem: {
    backgroundColor: "#252A38",
    padding: "8px 12px",
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
  },
  searchBoxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#252A38",
    borderRadius: "10px",
    width: "200px",
    padding: "0px 10px",
  },
  userNameAvatar: {
    width: "30px",
    height: "30px",
    backgroundColor: "#6C65D9",
    borderRadius: "50%",
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "500",
  },
  leaveButton: {
    backgroundColor: "#D61F1F29",
    color: "#FF4141",
    padding: "4px 8px",
    borderRadius: 10,
    fontFamily: "Poppins",
    fontSize: 12,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 120,
    height: 29,
    "&:hover": {
      background: "#B91A1A", // darker on hover
      transform: "translateY(-1px)",
      color: " #FFFFFF",
    },

    "&:active": {
      transform: "scale(.98)",
    },
  },
  removeButton: {
    backgroundColor: "#6C65D929",
    color: "#9992FF",
    padding: "4px 8px",
    borderRadius: 10,
    fontFamily: "Poppins",
    fontSize: 12,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 120,
    height: 29,
    "&:hover": {
      background: "#6C65D9", // darker on hover
      transform: "translateY(-1px)",
      color: " #FFFFFF",
    },

    "&:active": {
      transform: "scale(.98)",
    },
  },
  selectRoleDropdown: {
    width: "150px",
    height: "40px",
    backgroundColor: "#252A38",
    color: "#fff",
    borderRadius: "10px",
    border: "none",
    padding: "10px 8px !important",
    "& .MuiSelect-select": {
      color: "#fff",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
    "& .MuiSelect-iconOpen": {
      color: "#fff",
    },
  },
  singleRole: {
    color: "#fff !important",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  cardContentInput1: {
    padding: "0.2px 6px",

    "& .MuiInputBase-input": {
      padding: "6px",
      backgroundColor: "#252A38",
      opacity: 1,
      fontSize: "16px",
      color: "white",
      fontFamily: "poppins",
      borderRadius: "10px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
    },
    "&.Mui-disabled .MuiInputBase-input": {
      color: "gray",
    },
  },
  inputLabel: {
    color: theme.palette.text.tertiary,
    display: "inline-block",
  },

  upgradePlanBox: {
    // width: "100%",
    // height: "189px",
    background: "rgba(27, 29, 40, 0.6)",
    borderRadius: "10px",
    padding: "16px 12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "14px",
  },

  upgradeInfoIcon: {
    width: "20px",
    height: "20px",
    color: "#B1B5C9",
  },

  upgradeText: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "20px",
    color: "#B1B5C9",
  },

  upgradeButton: {
    height: "37px",
    borderRadius: "10px",
    backgroundColor: "#6C65D9",
    textTransform: "none",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 400,
    color: "#F9F9F9",

    "&:hover": {
      backgroundColor: "#5B55C9",
    },
  },
  warningBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#EFB13A4D",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #EFB13A",
    color: "#F9F9F9",
    marginBottom: "16px",
  },

  lockWarningBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#EF763A4D ",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #EF763A",
    color: "#F9F9F9",
    marginBottom: "16px",
    justifyContent: "start",
  },

  inactiveWarningBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#EF3A3A4D ",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #EF3A3A",
    color: "#F9F9F9",
    marginBottom: "16px",
    justifyContent: "start",
  },

  warningAction: {
    // marginLeft: "auto",
    cursor: "pointer",
    fontWeight: 500,
    textAlign: "left",
    color: "#F9F9F9",
    fontSize: "14px !important",
  },
}));

export default myTeamsPageStyles;
